import {useTranslation} from "react-i18next";
import {RemoveIcon} from "../../../../../../../../components/ui/RemoveIcon";
import {Link} from "react-router-dom";
import LordIcon from "../../../../../../../../components/ui/LordIcon";
import {Colors} from "../../../../../../../../components/theme";
import {Input, InputWrapperDiv} from "../../../../../../../../components/ui/Input";
import React from "react";

export default function Solistes({dataset, dispatch}) {
    const {t} = useTranslation();

    const viewData = () => {
        const view_list = dataset.map((item, index) => {
            return (
                <li key={item.pk}>
                    {index + 1}. {item.first_name} {item.last_name}
                    <div className='row pb-2'>
                        <InputWrapperDiv>
                            <Input
                                placeholder='Comment *'
                                name='comment_solist'
                                value={item.comment}
                                onChange={val => dispatch({type: "SET_COMMENT_SOLIST", comment: val, pk: item.pk})}
                                readOnly={true}
                            />
                        </InputWrapperDiv>
                    </div>

                    <div
                        className='customSelectParent'
                        style={{position: "relative"}}>
                        <RemoveIcon
                            className='fa fa-times'
                            onClick={() => dispatch({
                                type: 'REMOVE_SOLIST',
                                pk: item.pk
                            })}
                        />
                    </div>
                </li>
        )}
        )
        return dataset.length > 0 ? view_list : <div className="py-2 ps-1">{t("common.titles.to_define")}</div>
        }

        return (
        <>
            {viewData()}
            <div className="mt-2">
                <Link className="addGroup" to={""} onClick={() => dispatch({type: "CREATE_POPUP_SOLIST"})}>
                    <LordIcon url='cross' color={`${Colors.red};`} rotate='45' target='.addGroup'/>
                    <span className="ps-2">{t("common.button.add")}</span>
                </Link>
            </div>
        </>)
}